import PropTypes from "prop-types";

import { Button } from "@transfr-inc/dashboard-components/forms";

import { Card, CardBody, CardHeader, useExternalLink } from "@features/ui";
import { buttonTracking } from "@lib/tracking.helpers";

import { CertificationsSection } from "./components/certifications.section";
import { ProgramsSection } from "./components/programs.section";

import "./index.scss";

export const PostHighSchool = ({ careerId, onClose }) => {
  const { blocked, open } = useExternalLink();

  const onInstitutionClick = (institution) =>
    open(institution.webAddr, { label: institution.name });

  return (
    <Card className="post-high-school-card">
      <CardHeader
        title={<h1>Extended Learning</h1>}
        toolbar={
          <Button
            onClick={onClose}
            icon={["fa-regular", "xmark"]}
            {...buttonTracking("post-high-school", "close")}
          />
        }
      />
      <CardBody className="post-high-school-card-body">
        <CertificationsSection careerId={careerId} />
        <ProgramsSection
          careerId={careerId}
          onInstitutionClick={blocked ? undefined : onInstitutionClick}
        />
      </CardBody>
    </Card>
  );
};

PostHighSchool.displayName = "Post High School Card";

PostHighSchool.propTypes = {
  careerId: PropTypes.number,
  onClose: PropTypes.func,
};
